module.exports = __webpack_public_path__ + "static/img/commit.29635b70.png";